export default {
    '&.Mui-disabled, &[aria-disabled=true]': {
        opacity: '40%',
    },
};
